import { render, staticRenderFns } from "./CategorySelectList.vue?vue&type=template&id=7637ba4e&scoped=true&"
import script from "./CategorySelectList.vue?vue&type=script&lang=js&"
export * from "./CategorySelectList.vue?vue&type=script&lang=js&"
import style0 from "./CategorySelectList.vue?vue&type=style&index=0&id=7637ba4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7637ba4e",
  null
  
)

export default component.exports